import type { MedplumClient } from "@medplum/core";
import type { Observation, QuestionnaireResponse, Reference } from "@medplum/fhirtypes";

import { applyQuestionnaireResponseEncounterParentVersionId } from "@/encounters/utils/questionnaire-response-amend-stamp";

export interface UpdateLaborFlowsheetQuestionnaireResponseInput {
  questionnaireResponse: QuestionnaireResponse;
  /** When set, replaces `partOf` with this labor-stage reference; otherwise clears `partOf`. */
  laborStagePartOf?: Reference<Observation>;
  encounterQuestionnaireParentVersionId?: string;
}

/**
 * Stamps encounter parent version id (when provided), sets labor-stage `partOf`, and updates the QR.
 */
export async function updateLaborFlowsheetQuestionnaireResponse(
  medplum: MedplumClient,
  input: UpdateLaborFlowsheetQuestionnaireResponseInput,
): Promise<QuestionnaireResponse> {
  const stampedQuestionnaireResponse = applyQuestionnaireResponseEncounterParentVersionId(
    input.questionnaireResponse,
    input.encounterQuestionnaireParentVersionId,
  );

  return medplum.updateResource({
    ...stampedQuestionnaireResponse,
    partOf: input.laborStagePartOf ? [input.laborStagePartOf] : undefined,
  });
}
